import * as RadixAccordion from '@radix-ui/react-accordion';
import { AccordionProps } from './Accordion.types';
import { accordion } from './Accordion.styles';
import { ChevronDownIcon } from '@onbeam/icons/business';

export const Accordion = ({ title, children, ...props }: AccordionProps) => {
  const classes = accordion();

  return (
    <RadixAccordion.Item {...props}>
      <RadixAccordion.Trigger className={classes.trigger}>
        {title}
        <ChevronDownIcon height={16} width={16} className={classes.chevron} />
      </RadixAccordion.Trigger>
      <RadixAccordion.Content className={classes.content}>
        {children}
      </RadixAccordion.Content>
    </RadixAccordion.Item>
  );
};
